import classNames from 'classnames';
import { forwardRef } from 'react';
import SecurityShieldSvg from '../assets/security_shield.svg';
const formFooterCss = "f10l50i7";
export const FormFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formFooterCss, props.className)} />;
});
const securityShieldIconCss = "se1y7x2";
export const SecurityShieldIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = SecurityShieldSvg;
  return <Component ref={ref} {...restProps} src={src} aria-hidden className={classNames(securityShieldIconCss, props.className)} />;
});
const bannerInnerContainerCss = "b1yvsr05";
export const BannerInnerContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bannerInnerContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");